module.exports = __webpack_public_path__ + "static/media/iot-application-02.a755df7f.jpg";